module.exports = __webpack_public_path__ + "img/bust.a9388676.png";